/**
 * Panel obľúbených – vysúvací drawer v hlavičke.
 *
 * Dáta berie z window.DexWishlist (assets/dex-wishlist.js), ktorý rieši
 * rozdiel medzi hosťom a prihláseným. Tento súbor je len vykreslenie.
 */
(function () {
  'use strict';

  function init() {
    var api = window.DexWishlist;
    if (!api) return;

    var cfg = window.DexWishlistConfig || {};
    var trigger = document.querySelector('[data-dex-wl-open]');
    var overlay = document.querySelector('[data-dex-wl-overlay]');
    var drawer = document.querySelector('[data-dex-wl-drawer]');
    var body = document.querySelector('[data-dex-wl-body]');
    var badge = document.querySelector('[data-dex-wl-count]');
    if (!trigger || !drawer || !body) return;

    /* ---------- strážny pes ---------- */

    // Prepínač existuje len pre prihláseného – Liquid ho hosťovi nevykreslí.
    var notifyInput = drawer.querySelector('[data-dex-wl-notify]');
    var notifyError = drawer.querySelector('[data-dex-wl-notify-error]');

    function syncNotify() {
      if (notifyInput) notifyInput.checked = api.watchdog;
    }

    if (notifyInput) {
      syncNotify();
      // Strážneho psa môže zapnúť aj zvonček na produktovej stránke.
      document.addEventListener('dex:watchdog', syncNotify);
      notifyInput.addEventListener('change', function () {
        var wanted = notifyInput.checked;
        notifyInput.disabled = true;
        if (notifyError) notifyError.hidden = true;

        api
          .setWatchdog(wanted)
          .catch(function (error) {
            console.error('wishlist notify:', error);
            if (notifyError) notifyError.hidden = false;
          })
          .then(function () {
            // Po úspechu aj po chybe ukážeme to, čo je naozaj uložené.
            syncNotify();
            notifyInput.disabled = false;
          });
      });
    }

    /* Drawer sa renderuje vnútri header.liquid, ale <sticky-header> má
       position: sticky a z-index: 100, čím vytvára stacking context – z neho
       sa potomok nedostane žiadnou hodnotou z-index. Presunieme ho preto pod
       <body>. Rieši to zároveň prípadné orezanie cez overflow na predkoch. */
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    var money;
    try {
      money = new Intl.NumberFormat(cfg.locale || 'sk-SK', {
        style: 'currency',
        currency: cfg.currency || 'EUR',
      });
    } catch (e) {
      money = null;
    }

    function formatPrice(cents) {
      var value = Number(cents);
      if (!isFinite(value)) return '';
      // Admin API aj /products.js vracajú sumu v najmenšej jednotke meny.
      var amount = value / 100;
      return money ? money.format(amount) : amount.toFixed(2);
    }

    /* ---------- otváranie ---------- */

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      if (overlay) overlay.hidden = false;
      // Trieda až v ďalšom rámci, inak sa prechod nespustí z hidden stavu.
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      render();
      var closeBtn = drawer.querySelector('[data-dex-wl-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
      }, 280);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    trigger.addEventListener('click', open);
    if (overlay) overlay.addEventListener('click', close);
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-dex-wl-close]')) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) close();
    });

    /* ---------- vykreslenie ---------- */

    function itemNode(item) {
      var row = document.createElement('div');
      row.className = 'dex-wl-item';
      row.dataset.variantId = item.id;

      var media = document.createElement('div');
      media.className = 'dex-wl-item__media';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.imageAlt || item.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      var info = document.createElement('div');

      var link = document.createElement('a');
      link.className = 'dex-wl-item__title';
      link.href = '/products/' + item.handle + '?variant=' + item.id;
      link.textContent = item.title || '';
      info.appendChild(link);

      // "Default Title" je Shopify zástupný názov pri produkte bez variantov.
      if (item.variantTitle && item.variantTitle !== 'Default Title') {
        var variant = document.createElement('div');
        variant.className = 'dex-wl-item__variant';
        variant.textContent = item.variantTitle;
        info.appendChild(variant);
      }

      var price = document.createElement('div');
      price.className = 'dex-wl-item__price';
      price.textContent = formatPrice(item.price);
      info.appendChild(price);

      if (!item.available) {
        var soldout = document.createElement('div');
        soldout.className = 'dex-wl-item__soldout';
        soldout.textContent = 'Vypredané';
        info.appendChild(soldout);
      }

      var actions = document.createElement('div');
      actions.className = 'dex-wl-item__actions';

      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'dex-wl-item__add';
      add.textContent = 'Do košíka';
      add.disabled = !item.available;
      add.addEventListener('click', function () {
        add.disabled = true;
        add.textContent = 'Pridávam…';

        /* Postupujeme rovnako ako <add-to-cart> v global.js: mini košík si
           vypýta svoje sekcie, pošlú sa s požiadavkou a odpoveďou sa potom
           prekreslí. Samotná udalosť na to nestačí – bez renderContents by
           sa produkt do košíka pridal, ale nikde by to nebolo vidieť. */
        var miniCart = document.querySelector('mini-cart');
        var sections =
          miniCart && typeof miniCart.getSectionsToRender === 'function'
            ? miniCart.getSectionsToRender().map(function (s) {
                return s.id;
              })
            : [];

        var addUrl =
          (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ||
          '/cart/add.js';

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
          },
          body: JSON.stringify({
            id: Number(item.id),
            quantity: 1,
            sections: sections,
            sections_url: window.location.pathname,
          }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (state) {
            // Shopify vracia 422 v tele odpovede, nie v HTTP stave.
            if (state && state.status === 422) {
              throw new Error(state.description || 'Produkt sa nepodarilo pridať');
            }

            add.textContent = 'Pridané';

            if (miniCart && typeof miniCart.renderContents === 'function') {
              /* Bočný košík témy sa otvára s animáciou a náš panel (z-index
                 10001) by ho prekryl. Zákazník presúva vec z obľúbených do
                 košíka, takže má skončiť v košíku – panel zavrieme.
                 Poradie je dôležité: close() vracia focus na srdiečko
                 v hlavičke, takže musí prebehnúť skôr, než si focus
                 zoberie otvárajúci sa košík. */
              close();
              miniCart.renderContents(state);
            }
            // Bez bočného košíka panel necháme otvorený s "Pridané" –
            // inak by zákazník nedostal žiadnu odozvu.

            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', { detail: { product: state } }),
            );
          })
          .catch(function (error) {
            console.error('wishlist add to cart:', error);
            add.textContent = 'Skúsiť znova';
            add.disabled = false;
          });
      });
      actions.appendChild(add);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'dex-wl-item__remove';
      remove.textContent = 'Odobrať';
      remove.addEventListener('click', function () {
        remove.disabled = true;
        api.toggle(item.id, item.handle).catch(function (error) {
          console.error('wishlist remove:', error);
          remove.disabled = false;
        });
      });
      actions.appendChild(remove);

      row.appendChild(media);
      row.appendChild(info);
      row.appendChild(actions);
      return row;
    }

    var renderToken = 0;

    function render() {
      if (drawer.hidden) return;

      if (!api.count) {
        body.innerHTML = '<p class="dex-wl-drawer__empty">Zatiaľ tu nič nemáte.</p>';
        return;
      }

      var token = ++renderToken;
      body.innerHTML = '<p class="dex-wl-drawer__empty">Načítavam…</p>';

      api
        .detailed()
        .then(function (list) {
          // Medzitým mohol prísť ďalší render – ten starší už nezobrazujeme.
          if (token !== renderToken || drawer.hidden) return;

          // Odpoveď servera nesie aj aktuálny stav súhlasu.
          syncNotify();

          body.innerHTML = '';
          if (!list.length) {
            body.innerHTML = '<p class="dex-wl-drawer__empty">Zatiaľ tu nič nemáte.</p>';
            return;
          }
          var frag = document.createDocumentFragment();
          list.forEach(function (item) {
            frag.appendChild(itemNode(item));
          });
          body.appendChild(frag);
        })
        .catch(function (error) {
          if (token !== renderToken) return;
          console.error('wishlist drawer:', error);
          body.innerHTML =
            '<p class="dex-wl-drawer__empty">Zoznam sa nepodarilo načítať.</p>';
        });
    }

    /* ---------- počítadlo ---------- */

    api.subscribe(function (list) {
      if (badge) {
        badge.textContent = String(list.length);
        badge.hidden = list.length === 0;
      }
      // Číslo v bubline je pred čítačkou skryté, rovnako ako pri košíku –
      // počet preto nesie popis tlačidla.
      trigger.setAttribute(
        'aria-label',
        list.length ? 'Obľúbené produkty (' + list.length + ')' : 'Obľúbené produkty',
      );
      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
